import { RichTextEditor, useRichTextEditorContext } from '@mantine/tiptap';
import cx from 'clsx';
import { useState } from 'react';

import { RichTextExtraTools, RichTextTools, ToolbarType } from 'shared/types/RichTextToolbar';

import classes from './RichTextEditorInline.module.scss';
import { WidgetDefaultStyles } from '../../../utils/typographyStyles';
import type { RichTextProps } from '../RichText';
import { RichTextToolbar } from '../RichTextToolbar';

type RichTextEditorInlineProps = {
  tools?: (RichTextTools | RichTextExtraTools)[];
  toolbarClassName?: string;
  widgetDefaultStyles?: WidgetDefaultStyles;
};

export function RichTextEditorInline(props: RichTextProps & RichTextEditorInlineProps) {
  const { tools, toolbarClassName, widgetDefaultStyles } = props;

  const { editor } = useRichTextEditorContext();
  const [, setEditorContentRef] = useState<HTMLDivElement | null>(null);

  return (
    <>
      <RichTextEditor.Toolbar className={cx(classes.toolbar, toolbarClassName)} sticky>
        <RichTextToolbar
          editor={editor}
          type={ToolbarType.Inline}
          tools={tools}
          widgetDefaultStyles={widgetDefaultStyles}
        />
      </RichTextEditor.Toolbar>
      <RichTextEditor.Content ref={setEditorContentRef} />
    </>
  );
}
